module.exports = __webpack_public_path__ + "static/js-e56e37dea453afc79e0a029d0c615488.png";